export const ATTR_NAME_SELECTION_START_POS = 'selectionStartPos';

export const getSelectionCrossBrowser = () => {
  return global && window.getSelection
    ? window.getSelection()
    : document.getSelection
      ? document.getSelection()
      : null;
};

// Re-selects current active selection.
// Is used to hide the mobile native callout, e.g. IOS.
export const toggleSelectionRanges = () => {
  setTimeout(() => {
    const s = getSelection();

    if ((s?.rangeCount || 0) > 0) {
      const r = s?.getRangeAt(0);

      if (s.toString()) {
        s?.removeAllRanges();
        setTimeout(() => {
          s?.addRange(r);
        }, 50);
      }
    }
  }, 50)
};

export const clearSelection = () => {
  if (typeof window !== "undefined" && window.getSelection) {
    if (window.getSelection().empty) {
      // Chrome
      window.getSelection().empty();
    } else if (window.getSelection().removeAllRanges) {
      // Firefox
      window.getSelection().removeAllRanges();
    }
  } else if (document.selection) {
    // IE?
    document.selection.empty();
  }
};